import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {enlargeTextAnimation} from '../../../../shared/animations/enlarge-text.animation';
import {showSlideRightAnimation} from '../../../../shared/animations/show-slide-right';
import {SavedReportComponentObject} from '../../../../shared/classes/saved-report-component-object';
import {FolderComponentObject} from '../../../../shared/classes/folder-component-object';

@Component({
  selector: 'app-search-results-item',
  templateUrl: './search-results-item.component.html',
  styleUrls: ['./search-results-item.component.scss'],
  animations: [
    enlargeTextAnimation,
    showSlideRightAnimation
  ]
})
export class SearchResultsItemComponent {
  @Input() public item: SavedReportComponentObject | FolderComponentObject;

  @Output() public onFilter: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onOpen: EventEmitter<void> = new EventEmitter<void>();

  public enlargeText: string = 'normal';
  public showActions: boolean = false;

  public readonly badgeColors: any = {
    performance: '#6aa9da',
    cycle: '#a4d2d7',
    chart: '#122a62',
    dashboard: '#abc9f1',
    affinity: '#dbeafe',
    'transaction-id': '#b9bdef',
    'path-explorer': '#9dc5fe'
  };

  constructor() {}

  @HostListener('mouseenter') public onMouseEnter(): void {
    this.enlargeText = 'large';
    this.showActions = true;
  }

  @HostListener('mouseleave') public onMouseLeave(): void {
    this.enlargeText = 'normal';
    this.showActions = false;
  }

  @HostListener('click') public onClick(): void {
    this.onOpen.emit();
  }
}
